import styled from 'styled-components';

export const HintContainer = styled.div`
  position: absolute;
  top: 5%; left: 50%;
  transform: translate(-50%);
  width: 100%;
  z-index: 90;
`;

export const HintText = styled.p`
  margin: 12px;
  color: white;
  text-align: center;
`;
